import { render, staticRenderFns } from "./DashboardDeliveryConsultGraph.vue?vue&type=template&id=83242c52&scoped=true&"
import script from "./DashboardDeliveryConsultGraph.vue?vue&type=script&lang=ts&"
export * from "./DashboardDeliveryConsultGraph.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83242c52",
  null
  
)

export default component.exports